<script>
    import defaultLogo from "../image/default_logo.png";

    export let logoUrl = "";
    export let name;
    export let logoSize = 65;

    let src;
    $: src = logoUrl || defaultLogo;
</script>

<div style="height: {logoSize}px">
    <img width="{logoSize}" {src} alt={name} />
    <slot>
        <h3>{name}</h3>
    </slot>
</div>

<style>
    div {
        width: 100%;
        display: flex;
        flex-direction: row;
    }

    h3 {
        margin-left: 1em;
    }
</style>
